import { FC, useMemo } from 'react';

import { useEventAggregatesQuery } from '../../hooks/useEventAggregatesQuery';
import { useEventFilterContext } from './filter';
import { SummaryQueryState, SummaryQueryContext } from './query';

export const SummaryQueryProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { dateRange } = useEventFilterContext();

  const { data, error, isError, isLoading } = useEventAggregatesQuery(dateRange);

  const events = useMemo(() => data?.UserProfileEvents?.flat(1) || [], [data]);

  const context: SummaryQueryState = {
    error: error as string,
    isError,
    isLoading,
    events,
  };

  return <SummaryQueryContext.Provider value={context}>{children}</SummaryQueryContext.Provider>;
};
